export enum RoleNames {
  ADMIN = "admin",

  ASSOCIATION = "association",

  PARTNER = "partner",
}
